"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLowercaseLiteral = exports.difference = exports.LOGICAL_OPERATORS = void 0;
exports.keysOf = keysOf;
exports.Truthy = Truthy;
exports.includes = includes;
exports.assertTruthy = assertTruthy;
exports.strictUnionArray = strictUnionArray;
exports.LOGICAL_OPERATORS = strictUnionArray()(['AND', 'OR']);
function keysOf(obj) {
    return Object.keys(obj);
}
function Truthy(value) {
    return Boolean(value);
}
function includes(t, input) {
    return t.some(item => item === input);
}
function assertTruthy(value) {
    if (!Truthy(value)) {
        throw new Error('Expected value to be truthy');
    }
}
const difference = (t1, t2) => t1.filter(item => !t2.includes(item));
exports.difference = difference;
const toLowercaseLiteral = (value) => value.toLowerCase();
exports.toLowercaseLiteral = toLowercaseLiteral;
function strictUnionArray() {
    return (items) => [...items];
}
